export default "__VITE_ASSET__Cim24qf5__"